import SubscribeEventsOnboardingImpl from './subscribe-events-onboarding.jsx';
import MojitoCore from 'mojito/core';

/**
 * SubscribeEventsOnboarding component. Typically component is shown first time user interacts with event notification subscription options.
 *
 * @class SubscribeEventsOnboarding
 * @memberof Mojito.Modules.EventNotifications
 */
export default MojitoCore.Presentation.UIView(
    'SubscribeEventsOnboarding',
    SubscribeEventsOnboardingImpl
);
